import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { VersionInfoDto } from '../models/version-info.model';

@Injectable({
  providedIn: 'root',
})
export class VersionInfoService {
  apiName = 'Default';
  constructor(private restService: RestService) {}

  getVersionInfo = () =>
    this.restService.request<void, VersionInfoDto>(
      {
        method: 'GET',
        url: `/api/app/version`,
      },
      { apiName: this.apiName }
    );
}
